module.exports = __webpack_public_path__ + "static/media/icons_Bilan prévention des blessures.dc66fe58.svg";